import { skillGroupActions } from '../skillGroups/skillGroup-slice';
import { getData } from '../common-actions';
import { fetchSkillGroups, fetchSkillGroupMembers, fetchSkillGroup, fetchSkillGroupDivisions } from '../../lib/api';

export const getSkillGroups = (token, signal) => {

  return getData({
    token: token,
    actions: skillGroupActions,
    fetchFn: (token) => fetchSkillGroups(token, signal),
    dataKey: "skillGroups",
    name: "get skillGroups",
    setFunctionName: "setSkillGroups"
  });
};

export const getSkillGroupMembers = (token, groupId, signal) => {
 
  return getData({
    token: token,
    actions: skillGroupActions,
    fetchFn: (token) => fetchSkillGroupMembers(token, groupId, signal),
    dataKey: "skillGroupMembers",
    name: "get skillGroup members",
    setFunctionName: "setSkillGroupMembers"
  });
};


export const getSkillGroup = (token, groupId, signal) => {

  return (dispatch, getState) => {

    dispatch(getData({
        token: token,
        actions: skillGroupActions,
        fetchFn: (token) => fetchSkillGroup(token, groupId, signal),
        dataKey: "skillGroup",
        name: "get skillGroup",
        setFunctionName: "setSkillGroup"
      })
    );

    dispatch(getData({
        token: token,
        actions: skillGroupActions,
        fetchFn: (token) => fetchSkillGroupDivisions(token, groupId, signal),
        dataKey: "skillGroupDivisions",
        name: "get skillGroupDivisions",
        setFunctionName: "setSkillGroupDivisions"
      }));
  }

/*
  return getData({
    token: token,
    actions: skillGroupActions,
    fetchFn: (token) => fetchSkillGroup(token, groupId, signal),
    dataKey: "skillGroup",
    name: "get skillGroup",
    setFunctionName: "setSkillGroup"
  });
*/  
/*
  return getData({
    token: token,
    actions: skillGroupActions,
    fetchFn: (token) => fetchSkillGroupDivisions(token, groupId, signal),
    dataKey: "skillGroupDivisions",
    name: "get skillGroupDivisions",
    setFunctionName: "setSkillGroupDivisions"
  });
*/
};

export const clearSkillGroup = () => {
  return async (dispatch) =>{
    dispatch(
      skillGroupActions["clearSkillGroup"]()
    );
  };

};
